import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CelebsContext } from '../../../contexts/celebsContext';
import { LangContext } from '../../../contexts/langContext';
import { SocialContext } from '../../../contexts/socialContext';
import { StateContext } from '../../../contexts/stateContext';
import { Celebs } from '../../Lists/Celebs';
import { ListAvatars } from '../../Lists/ListAvatars';
import { ListAvatarsLayout } from '../../Lists/ListAvatarsLayout';
import { ListCity } from '../../Lists/ListCity';
import { SocialChoose } from '../../UiKit/SocialChoose';
import { SocialFilters, filterArrayByStats, matchesStatsFilter } from '../../UiKit/SocialFilters';


export const PentasBrowser = memo((props) => {
  const context = {
    ...useContext(SocialContext),
    ...useContext(StateContext),
    ...useContext(LangContext),
    ...useContext(CelebsContext),
  };
  const $ui = context.$ui;



  const navigate = useNavigate();

  const {
    title = '',
    includeMe = true,
    pentaId,
    scope = [],
    exclude = [],
    chosen = [],
    customHandler = () => void (0),
    customHandlerChosen = () => void (0),
    expanded,
    children,
    peopleShown = false,
    handleClose,
    mode = 'hd',
  } = { ...props };
  const [searchParams] = useSearchParams();







  const [penta, setPenta] = useState();
  const [pentaId2, setPentaId2] = useState();
  const [pentaAvatars, setPentaAvatars] = useState();
  const [filter, setFilter] = useState(mode === 'hd' ? 'types' : 'yoni');
  const [statsFilter, setStatsFilter] = useState(null);




  const [socialView, setSocialViewInner] = useState(['people', 'followers'])
  // const [socialView, setSocialViewInner] = useState(['world', 'people', 'followers', 'bodygraphs'])

  const setSocialView = (what) => {
    // if (socialView.includes(what)) {
    //   setSocialViewInner(prev => prev.filter(one => one !== what))
    // } else {
    //   setSocialViewInner(prev => [...prev, what])
    // }
    // console.log('what = ', what);
    setSocialViewInner(what)
    setStatsFilter(null)
    // context.x.setCurrentPeopleSet(['what'])
  }


  const filterMeOut = (array) => array.filter(one => {
    // return one
    // console.log('one.avatar.token = ', one.avatar.token);
    return one.avatar.token !== context.me.avatar.token
  })


  const peoplePanelRef = useRef(null);

  useEffect(() => {
    if (expanded) {
      // peoplePanelRef.current.scrollTop = 0;
      // setSocialView(context.state.currentPeopleSet)
    } else {
      // setSocialView(context.state.currentPeopleSet)
      if (socialView[0] === 'world') setSocialViewInner(['people', 'followers'])
      setStatsFilter(null)
    }
  }, [expanded]);


  const filterOutFriends = (excludeTokens = []) => {
    const arrayFollowers = context.followers;
    const arrayFollowings = context.followings;
    let friendsTokens = arrayFollowings.filter(one => one?.user?.token).map(one => one.user.token)
    let onlyFollowings = friendsTokens.length ? arrayFollowers.filter(one => {
      return !friendsTokens.includes(one.user.token)
    }) : arrayFollowers
    return onlyFollowings.filter(one => !excludeTokens.includes(one.user.token))
  }

  const followingsCount = context.me?.user?.aggr?.followings_count || 0;
  const meUserToken = context.me?.user?.token;
  const loadedFollowings = Array.isArray(context.followings)
    ? context.followings.filter(
      (one) => one && (!includeMe || one?.user?.token !== meUserToken)
    ).length
    : 0;
  const followingsListQuantity = context.followingsComplete
    ? loadedFollowings + (includeMe && context.me ? 1 : 0)
    : followingsCount + (includeMe && context.me ? 1 : 0);

  const peopleArray = useMemo(() => {
    const meUserToken = context.me?.user?.token;
    const arr = context.followings
      ? context.followings.filter(
        (one) => one && (!includeMe || one?.user?.token !== meUserToken)
      )
      : [];
    return includeMe && context.me ? [context.me, ...arr] : arr;
  }, [context.followings, context.me, includeMe]);

  const followersArray = useMemo(
    () => (context.followers ? filterOutFriends(exclude) : []),
    [context.followers, context.followings, exclude]
  );

  // filterOutFriends shrinks the list — quantity must match the rendered array,
  // not aggr/followers_count, or ListAvatars keeps requesting forever.
  const followersListQuantity = followersArray.length;

  const avatarsArray = useMemo(
    () => (context.avatars ? filterMeOut(context.avatars) : []),
    [context.avatars, context.me]
  );

  const celebsArray = useMemo(
    () => (context.celebsData ? [...context.celebsData] : []),
    [context.celebsData]
  );

  const applyListStatsFilter = useCallback((array, listId) => {
    if (!statsFilter || statsFilter.listId !== listId) return array;
    return filterArrayByStats(array, statsFilter);
  }, [statsFilter]);

  const filteredPeople = useMemo(
    () => applyListStatsFilter(peopleArray, 'followings'),
    [peopleArray, applyListStatsFilter]
  );

  const filteredFollowers = useMemo(
    () => applyListStatsFilter(followersArray, 'followers'),
    [followersArray, applyListStatsFilter]
  );

  const filteredAvatars = useMemo(
    () => applyListStatsFilter(avatarsArray, 'avatars'),
    [avatarsArray, applyListStatsFilter]
  );

  const filteredCelebs = useMemo(
    () => applyListStatsFilter(celebsArray, 'celebs'),
    [celebsArray, applyListStatsFilter]
  );

  const handleStatsSelect = (listId) => (match) => {
    setStatsFilter((prev) => {
      if (match.profile) {
        const sameProfile = prev?.listId === listId
          && prev?.type === match.type
          && prev?.profile?.[0] === match.profile[0]
          && prev?.profile?.[1] === match.profile[1];
        if (sameProfile) {
          return { listId, type: match.type };
        }
        return { listId, type: match.type, profile: match.profile };
      }
      if (match.type) {
        if (prev?.listId === listId && prev?.type === match.type) {
          return null;
        }
        return { listId, type: match.type };
      }
      if (prev?.listId === listId && matchesStatsFilter(prev, match)) {
        return null;
      }
      return { listId, ...match };
    });
  };

  const clearStatsFilter = useCallback(() => setStatsFilter(null), []);

  const toggleStatsMode = useCallback(() => {
    setFilter((prev) => (prev === 'types' ? 'profiles' : 'types'));
  }, []);

  const statsProps = (listId, array) => ({
    mode,
    type: filter,
    array,
    onSelect: handleStatsSelect(listId),
    activeFilter: statsFilter?.listId === listId ? statsFilter : null,
    onClear: clearStatsFilter,
    onToggleMode: mode === 'hd' ? toggleStatsMode : undefined,
    ready: listId === 'followings'
      ? Boolean(context.followingsComplete)
      : listId === 'followers'
        ? Boolean(context.followersComplete)
        : true,
  });

  const options = [
    {
      id: 'celebs',
      icon: 'star',
      handleValue: ['celebs'],
      title: 'people_celebs',
    },
    {
      id: 'people',
      icon: 'group',
      handleValue: ['people', 'followers'],
      title: 'people_people',
    },
    {
      id: 'bodygraphs',
      icon: 'person_search',
      handleValue: ['bodygraphs'],
      title: 'people_bodygraphs',
    },
  ].filter(one => scope.includes(one.id))






  return (
    <>



      <div className={expanded ? "x_choose_panel x_choose_panel--pentas active" : "x_choose_panel x_choose_panel--pentas active"}>
        <div className={expanded ? "x_choose0 active" : "x_choose0"}>



          <div ref={peoplePanelRef} className='x_people_panel active'>






            <div
              className={"x_choose_left x_choose_left--open"}
            // className={"x_choose_left"}
            >



              <div className={"x_choose_container x_choose_container--v"}>

                <div className={"x_panel_h x_panel_h--pentasbrowser active"}>


                  {Boolean(title) &&
                    <div className="x_choose_pentabrowser_title">
                      <div>{title}</div>
                    </div>}

                  {options.length > 1 && <SocialChoose
                    handle={setSocialView}
                    active={socialView}
                    options={options}
                  />}

                  <div className="x_panel_actions">
                    <div className="x_action" onClick={handleClose}>
                      <div className="t_icon t_icon--60">
                        expand_more
                      </div>
                    </div>
                  </div>

                </div>


                <div className="x_panel_h0" />


                <div className="x_choose_contents">


                  {socialView.includes('world') && expanded && <ListCity user={context.me.user} />}


                  <div className="x_choose_sect0">

                    {socialView.includes('people') && <ListAvatarsLayout
                      icon='group'
                      title={$ui('people_people')}
                      listId='people'
                      quantity={statsFilter?.listId === 'followings' ? filteredPeople.length : followingsCount}
                      className='v'
                      addLeft={<SocialFilters {...statsProps('followings', peopleArray)} />}
                    >
                      <ListAvatars
                        fullSrceen={true}
                        customHandler={customHandler}
                        listId='followings'
                        quantity={statsFilter?.listId === 'followings' ? filteredPeople.length : followingsListQuantity}
                        array={filteredPeople}
                        actions={[]}
                        chosen={chosen}
                        customHandlerChosen={customHandlerChosen}
                        paginate={context.state.paginate}
                      />
                    </ListAvatarsLayout>}



                    {socialView.includes('celebs') && <Celebs
                      customHandler={customHandler}
                      actions={[]}
                      addLeft={<SocialFilters {...statsProps('celebs', celebsArray)} />}
                      statsFilter={statsFilter?.listId === 'celebs' ? statsFilter : null}
                      filteredArray={statsFilter?.listId === 'celebs' ? filteredCelebs : null}
                    />}



                    {socialView.includes('followers') && <ListAvatarsLayout
                      icon='public'
                      title={$ui('people_followers')}
                      listId='followers'
                      quantity={statsFilter?.listId === 'followers' ? filteredFollowers.length : followersListQuantity}
                      className='v'
                      addLeft={<SocialFilters {...statsProps('followers', followersArray)} />}
                    >
                      <ListAvatars
                        fullSrceen={true}
                        customHandler={customHandler}
                        customHandlerChosen={customHandlerChosen}
                        chosen={chosen}
                        listId='followers'
                        quantity={statsFilter?.listId === 'followers' ? filteredFollowers.length : followersListQuantity}
                        array={filteredFollowers}
                        paginate={context.state.paginate}
                      />
                    </ListAvatarsLayout>}







                    {socialView.includes('bodygraphs') && <ListAvatarsLayout
                      title={$ui('people_bodygraphs')}
                      listId='avatars'
                      icon='person_search'
                      quantity={statsFilter?.listId === 'avatars' ? filteredAvatars.length : avatarsArray.length}
                      className='v'
                      addLeft={<SocialFilters {...statsProps('avatars', avatarsArray)} />}
                    >
                      <ListAvatars
                        customHandler={customHandler}
                        customHandlerChosen={customHandlerChosen}
                        chosen={chosen}
                        quantity={filteredAvatars.length}
                        listId='avatars'
                        array={filteredAvatars}
                        exclude={exclude}
                        actions={['edit', 'setMe', 'delete']}
                      />
                      {/* <CreateNew
                        icon='add'
                        label={$ui('button_create_new_bodygraph')}
                        handle={() => !context.creatingAva && context.x.createAvatar(
                        {},
                          (newUrl) => {
                            navigate(`/u/${newUrl}`)
                          }
                        )}
                        loading={context.creatingAva}
                      /> */}
                    </ListAvatarsLayout>}









                  </div>
                </div>



              </div>
              {/* } */}


            </div>


          </div>
          {expanded && <div className="x_choose_bg">
            <div className="x_edu_bg g" />
          </div>}



          {/* <WithVersion>{expanded && <Pentas />}</WithVersion> */}



        </div>
      </div>




    </>
  )
})


